export enum ROLE {
    ADMIN = 'admin',
    CHAUFFEUR = 'chauffeur',
    CLIENT = "client",
    FOURNISSEUR = 'fournisseur'
}

export const roleRouteMap: { [key in ROLE]: string } = {
  [ROLE.CHAUFFEUR]: "planning",
  [ROLE.FOURNISSEUR]: "planning",
  [ROLE.CLIENT]: "bons",
  [ROLE.ADMIN]: "bons",
};